//Автоопределение buildType
const buildType =
    window.location.hostname === 'localhost'
        ? 'LOCAL'
        : window.location.hostname === 'app.dataheroes.pro'
        ? 'PRODUCTION'
        : 'TEST'

//const buildType = process.env.VUE_APP_BUILD_TYPE
const reportStaffIds = buildType === 'PRODUCTION' ? [51, 61, 62] : [8, 11]
const excelActivationId = buildType === 'PRODUCTION' ? 3611 : 6799
const uploadActivationId = buildType === 'PRODUCTION' ? 4080 : 6846
const frontendEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:8080'
        : buildType === 'PRODUCTION'
        ? 'https://app.dataheroes.pro'
        : 'https://app.crmmsk.ru'
const apiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3000/api'
        : buildType === 'PRODUCTION'
        ? 'https://bff.dataheroes.pro/api'
        : 'https://bff.crmmsk.ru/api'
const adminApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3005'
        : buildType === 'PRODUCTION'
        ? 'https://admin-backend.dataheroes.pro'
        : 'https://admin-backend.crmmsk.ru'
const chatEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:5173'
        : buildType === 'PRODUCTION'
        ? 'https://dh-chat.dataheroes.pro'
        : 'https://test-dh-chat.dataheroes.pro'
const updaterApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3000/api'
        : buildType === 'PRODUCTION'
        ? 'https://update.dataheroes.pro/api'
        : 'https://update.crmmsk.ru/api'
const authApiEndpoint =
    buildType === 'LOCAL'
        ? 'http://localhost:3001/api'
        : buildType === 'PRODUCTION'
        ? 'https://bff.dataheroes.pro/api'
        : 'https://bff.crmmsk.ru/api'
export default {
    excelActivationId,
    uploadActivationId,
    reportStaffIds,
    buildType,
    waitThaiEnabled: true,
    frontendEndpoint,
    apiEndpoint,
    adminApiEndpoint,
    chatEndpoint,
    updaterApiEndpoint,
    mqUrl: getMqUrl(),
    authApiEndpoint,
    adminApiEndopint: 'admin-backend.dataheroes.pro',
    amoCrmClientId:
        buildType === 'PRODUCTION'
            ? '3af37da7-bfbc-4a15-a4f0-29d757ad66b0'
            : 'be342937-0271-45c2-8507-dca06616c56a',
    zmClientId: buildType !== 'LOCAL' ? 'g3ed2ca22a9c6e0546b04e0b95b379' : 'gccc81de8d34384de0fc8c78c75d7e',
    zmConsumerKey: buildType !== 'LOCAL' ? 'f5e28444ee' : 'ca0a5f6d87',
    zmRedirectUri:
        buildType !== 'LOCAL' ? 'https://app.crmmsk.ru/OAuthLogin' : 'http://localhost:8080/OAuthLogin',
    disabledConnectorsTypes:
        buildType === 'PRODUCTION' ? ['alfa', 'planfact', 'zenmoney'] : ['alfa', 'planfact', 'zenmoney'],
    disabledDashboardsIds: buildType === 'PRODUCTION' ? ['outflow', 'attendance'] : ['outflow', 'attendance'],
    disabledSettings: { yClients: ['group', 'division'] },
    /** Тестовый ряд для графика «Прирост подписчиков» (только monthsDynamicsData). Ещё: ?chartMock=1 в URL */
    subscribersGrowthChartMock: false,
    yClientSimpleAuth: true, //Упрощенная авторизация yClients
    idleReloadTimeout: 60, //Minutes
    wsUrl: getWsUrl(),
    yMId: getYMId(),
    audienceWithReturnAfterVar: buildType === 'PRODUCTION' ? [708] : [3931],
    botYcAvailable: ['XL7CAR0RN', 'PBGXYGSEA'],
    adminsWhitelist: [
        'google-oauth2|103524613464469136207',
        'auth0|JTL-Xi4vzTXfbwTuIEF6_',
        'google-oauth2|106448966005337154243',
        'google-oauth2|111747802967162964419',
        'google-oauth2|112331075346786769506',
        'google-oauth2|115772460460441863064',
        'auth0|KXOuvv47jMzQaP0NMXG8o',
        'auth0|-vC_3_IHpkYuK9UDp91xn',
        'google-oauth2|116265841278486246844',
        'google-oauth2|106212038968126676728',
        'auth0|_KomYIgegHln9AShSzlde',
        'auth0|TSdF8ldOhnLJvyimYU0TT',
        'google-oauth2|102027286731767220713',
        'auth0|uoY16A1cgLHMiJHdO4S1U',
        'auth0|LZKTFm-eZdO-vQ_bJXSmv',
        'auth0|Pr-yAqoGybmWixlvOsM8-',
        'google-oauth2|110335629880405454179',
        'auth0|mQX7liSLMcVw2I4HHtRop',
        'google-oauth2|105973164533268684809',
        'google-oauth2|112947983865517618451',
        'google-oauth2|114458797360898224800',
        'auth0|hZBiNLLSWlbMIZfdYmIgG',
        'auth0|vSWYp8RG_eLpAwNwrNrsf',
        'google-oauth2|116576350167571712900',
        'auth0|Hjo1y1TZGcw1d5QfCVYSj',
        'auth0|aT7jK6_nA2DqfVPp5bMTB',
        'auth0|yX3FC_44t2eFUzF_f03pP',
        'auth0|JbZyD_LcI5QmZACMpVWfF',
        'auth0|608b19a53b759d006e5afc9e',
        'google-oauth2|109525517349680832067',
        'auth0|JvO13T07Xs-ECjyZV1s8I',
        'auth0|_zw4GOQBjBbWlxX0TwDKA',
        'auth0|Hjo1y1TZGcw1d5QfCVYSj',
        'google-oauth2|116576350167571712900',
        'auth0|vSWYp8RG_eLpAwNwrNrsf',
        'auth0|hZBiNLLSWlbMIZfdYmIgG',
        'google-oauth2|116265841278486246844',
        'google-oauth2|116791059376520238550',
        'auth0|JTL-Xi4vzTXfbwTuIEF6_',
        'google-oauth2|112888956121010043482',
        'google-oauth2|106300165045036256700',
        'auth0|60705cca60ca5d0069e2d917',
        'auth0|qRedS9OlwSWtU-wgllaAP',
        'google-oauth2|102970184635060069927',
        'google-oauth2|104759428919580821145',
        'auth0|IUvPsGUfbs_QZ8Gz0HGLb',
        'google-oauth2|105442293150208466125',
        'auth0|IUvPsGUfbs_QZ8Gz0HGLb',
        'google-oauth2|104759428919580821145',
        'auth0|FGVwjcmJOyD7nWujAAeyc',
        'auth0|aT7jK6_nA2DqfVPp5bMTB',
        'auth0|yX3FC_44t2eFUzF_f03pP',
        'auth0|JbZyD_LcI5QmZACMpVWfF',
        'auth0|z8cuWrDLVdhUVsLzvkxta',
        'auth0|fDAKMJlJlKtpesvUh5rpx',
        'google-oauth2|115424245281569842479',
        'google-oauth2|112689673382041930596',
        'auth0|HH21QVpwZrfCDvoD_ztsX',
        'auth0|BgS_h7GbPYlPceQS1BlGN',
        'auth0|M3SD8GrjufNbvAB-lO_W_',
        'google-oauth2|105157646882213297834',
        'auth0|zAiAMIV0-nQoGIuRDo99Q',
        'auth0|HS0tsQ75kCCyln9eF1LLQ',
        'auth0|g0NoykcfZxP3--8dLMW3L',
        'auth0|U3KfSVmxyHdNgZDFq6TFs',
        'google-oauth2|118407526504043998824',
        'auth0|yRqwh7vtvipk-sJrmevSN',
        'auth0|G3nNosfg-zjcs01K76VDj',
        'google-oauth2|107752152184752401225',
        'auth0|_jyhAGSOZxDrxKjtqrkVY',
    ],
    testerEmails: [],
    teymurovId: 'google-oauth2|108422277584517774015',
    // Список проектов, для которых показывать выбор способа оплаты (инвойсы)
    projectsWithPaymentMethodSelection: [
        'QYXDUF2V6',
        'GAXAQ57R2',
        'CWX728VPM',
        'FZXRXXN8D',
        'YSGJXLXSY',
        'YDX1S38H1',
        'NX8C8O88S',
        'X6KIWNNUW',
        'XP6JIZQY7',
        'XQ1DBFXUJ',
        'XLI81TR66',
        'MSZXBFHFE',
        'MJFKXT2W1',
        'XPT9N2XH3',
        'ATXEPF2V6',
        'X2W3IZCBX',
        'GEMOXQIFL',
    ],
    marketplaceModulesIds: {
        'LOCAL': {
            salesTraining: '56',
            beautyAutopilot: '53',
            crmSettings: '52',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '55',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '58',
            dhChat: 'dhChat',
            diagnostics: '60',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '65',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
        'TEST': {
            salesTraining: '56',
            beautyAutopilot: '53',
            crmSettings: '52',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '55',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '58',
            dhChat: 'dhChat',
            diagnostics: '60',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '65',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
        'PRODUCTION': {
            salesTraining: '46',
            beautyAutopilot: '42',
            crmSettings: '47',
            maxBusiness: 'maxBusinessChannelSlot',
            kpiSettings: '45',
            channels: 'channelSlot',
            zvonoBot: 'zvonoBot',
            crmTO: '44',
            dhChat: 'dhChat',
            diagnostics: '48',
            customCascades: 'customCascades',
            sms: 'smsChannelSlot',
            businessPulseReport: 'businessPulseReport',
            opz2: 'Opz2',
            hotWindows: 'hotWindows',
            webinars: '50',
            opz2KPISettings: 'opz2KPISettings',
            zvonoBotSettings: 'zvonoBotSettings'
        },
    },
}

function getWsUrl() {
    if (buildType === 'PRODUCTION') {
        return 'https://ws.dataheroes.pro/'
    } else {
        return 'https://ws.crmmsk.ru/'
    }
}
function getMqUrl() {
    if (buildType === 'PRODUCTION') {
        return 'https://mq.dataheroes.pro'
    } else {
        return 'https://mq.crmmsk.ru'
    }
}

function getYMId() {
    if (buildType === 'PRODUCTION') {
        return 90138959
    } else {
        return 110147856
    }
}
